import { Pipe, PipeTransform } from "@angular/core";
import { EstadosTipoEnum, obtenerNombreEstadosTipo } from "@shared/enums";


@Pipe({
    name: "toStrState"
})
export class ToStrStatePipe implements PipeTransform {

    transform(value: string): string {
        return obtenerNombreEstadosTipo(EstadosTipoEnum[value]);
    }

}
